import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {PorQue} from '@/components/ui/por-que'

// Who can operate but not certify (identity-access-spec §1a.3) sees why, never a silently disabled button.
export function CertBlockedBanner({reason, businessId}: {reason: string; businessId: string}) {
  const {t} = useTranslation()
  return (
    <div className="notice-amber rounded-lg px-4 py-3" data-testid="cert-blocked-banner">
      <p className="flex flex-wrap items-center gap-2 text-sm">
        {t('sgsst.certBlocked.banner', {reason})}
        <PorQue
          label={t('sgsst.certBlocked.porqueLabel')}
          testId="cert-blocked-porque"
          contenidoTestId="cert-blocked-porque-contenido">
          {t('sgsst.certBlocked.porqueBody')}
        </PorQue>
      </p>
      <Link
        to={`/businesses/${businessId}/mi/perfil`}
        className="mt-1 inline-block text-sm font-medium underline underline-offset-2"
        data-testid="cert-blocked-renew-cta">
        {t('sgsst.certBlocked.renewCta')}
      </Link>
    </div>
  )
}
